import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../hooks/useTheme';

export function ThemeToggle({ size = 14, title }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  const Icon = isDark ? Sun : Moon;
  const label = isDark ? 'Tema claro' : 'Tema escuro';

  return (
    <button
      onClick={toggle}
      title={title || label}
      aria-label={label}
      style={{
        border: 'none', background: 'transparent', cursor: 'pointer',
        color: 'var(--muted)', padding: 6, borderRadius: 6,
        display: 'inline-flex', alignItems: 'center',
        transition: 'color .15s, background .15s',
      }}
      onMouseOver={e => {
        e.currentTarget.style.background = 'var(--surface-2)';
        e.currentTarget.style.color = 'var(--primary)';
      }}
      onMouseOut={e => {
        e.currentTarget.style.background = 'transparent';
        e.currentTarget.style.color = 'var(--muted)';
      }}
    >
      <Icon size={size} strokeWidth={2.2} />
    </button>
  );
}
